import React from 'react';

export const Menu: React.FC<{color: string}> = ({color}: {color: string}) => (
  <svg width="28" height="15" viewBox="0 0 28 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="0.50293" y1="0.953125" x2="27.5029" y2="0.953125" stroke={color} />
    <line x1="0.50293" y1="7.45312" x2="27.5029" y2="7.45312" stroke={color} />
    <line x1="0.50293" y1="13.9531" x2="27.5029" y2="13.9531" stroke={color} />
  </svg>
);
